import React from 'react';
import { useLocation, Link } from 'react-router';
import { Badge, Gutter, HeaderBarLink, Layout, LayoutItem } from '@axiom/ui';

export type PreferencesNavigationItemProps = {
  children: React.ReactNode;
  name: string;
  target?: string;
  url: string;
  showBadge?: boolean;
};

export const PreferencesNavigationItem = ({
  children,
  name,
  target,
  url,
  showBadge = false,
}: PreferencesNavigationItemProps) => {
  const location = useLocation();
  return (
    <Layout name={`${name}_LAYOUT`}>
      <LayoutItem>
        <HeaderBarLink
          selected={location.pathname.endsWith(url.replace('../', ''))}
          name={name}
        >
          <Link to={url} target={target} data-test={`${name}_LINK`}>
            {children}
          </Link>
        </HeaderBarLink>
      </LayoutItem>
      {!!showBadge && (
        <LayoutItem>
          <Gutter left="8px">
            <Badge background="orange" name="NOTIFICATION_BADGE">
              1
            </Badge>
          </Gutter>
        </LayoutItem>
      )}
    </Layout>
  );
};
